export default __webpack_public_path__ + "static/media/register-succes.76016cfd.png";